<template>
<div class="chapter">
<div class="inner_page">
<p class="DED1"><a id="page_v">For Dylan and Caitlin.</a></p><a id="page_v">
<p class="DED2">I hope someday you have children <span class="txbf1">just like you.</span></p>
</a><p><a id="page_v"></a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?9ff360a0